import { createFileRoute } from "@tanstack/react-router";

import TodosFastlane from "@/features/todos/todos-fastlane";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/fastlane",
)({
  component: PayableFastlanePage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableFastlanePage() {
  return <TodosFastlane type="payable" />;
}
